import { render, staticRenderFns } from "./ShowProductRequest.vue?vue&type=template&id=a9ed92e8&"
import script from "./ShowProductRequest.vue?vue&type=script&lang=js&"
export * from "./ShowProductRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports